var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-container', [_vm.$route.query.profile ? _c('div', {
    staticClass: "d-flex text-center align-items-center top-div"
  }, [_c('router-link', {
    attrs: {
      "button": "",
      "to": "/profile"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "arrow-left-short"
    }
  })], 1), _c('h5', [_c('b', [_vm._v(_vm._s(_vm.$route.query.profile))])])], 1) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-table', {
    staticClass: "wishlis-table mt-3",
    attrs: {
      "items": _vm.listData,
      "fields": _vm.fields,
      "hover": "",
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(productImage)",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('b-img', {
          staticClass: "wishlist-img img-fluid",
          attrs: {
            "src": item.images.bigImage,
            "alt": "img"
          }
        })];
      }
    }, {
      key: "cell(description)",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('div', [_c('h6', {
          staticClass: "mt-0 mb-1"
        }, [_vm._v(" " + _vm._s(item.description_summary) + " ")])])];
      }
    }, {
      key: "cell(price)",
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('h6', {
          staticClass: "text-icon price-normal mb-0"
        }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + " " + _vm._s(item.Price) + " ")])];
      }
    }, {
      key: "cell(status)",
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('h5', {
          staticClass: "mb-0",
          class: item.Availability.toLowerCase().replace(/\s/g, '')
        }, [_vm._v(" " + _vm._s(_vm.formatAvailability(item.Availability)) + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('div', {
          staticClass: "d-flex justify-content-center align-items-center"
        }, [_vm.$options.components['checkout-increment-decrement'] && item.Availability.toLowerCase().trim() !== 'out of stock' ? [_c('checkout-increment-decrement', {
          staticClass: "wishlist-actions",
          attrs: {
            "callCheckout": true,
            "cartItem": item
          }
        })] : _vm._e(), _c('b-button', {
          staticClass: "text-dark ml-1 removeWishBtn",
          attrs: {
            "variant": "outline-danger"
          },
          on: {
            "click": function ($event) {
              return _vm.removeToWishList(item);
            }
          }
        }, [_c('b-icon', {
          attrs: {
            "icon": "x-circle"
          }
        })], 1)], 2)];
      }
    }])
  }), _c('b-col', {
    staticClass: "text-center",
    style: {
      display: _vm.listData.length === 0 ? '' : 'none'
    },
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('b-img', {
    attrs: {
      "inline": "",
      "src": "img/empty-wishlist.png",
      "fluid": ""
    }
  }), _c('h3', {
    staticClass: "font-weight-bold mb-4 mt-4"
  }, [_vm._v(" " + _vm._s(_vm.$t("wishlistProduct.empty")) + " ")]), _c('b-navbar-brand', [_c('b-button', {
    staticClass: "mb-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("wishlistProduct.continueShopping")))])], 1)], 1)])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }